import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Pill extends Component {
  handleClick = event => {
    const { disabled, handler } = this.props;

    if (!disabled && handler) {
      handler(event, this.props);
    }
  };

  render() {
    const { children, testId, tooltip, disabled } = this.props;

    if (!children) {
      return null;
    }

    return (
      <span
        aria-describedby={tooltip}
        data-test={`pill-${(testId || children).replace(/[^a-z0-9]/gi, '')}`}
        className="relative mr-3 inline-block  items-center rounded-md bg-orange-50 px-2.5 py-1 text-xs font-medium text-orange-700 inset-ring inset-ring-orange-600/20"
      >
        {children}
        {!disabled && (
          <button
            onClick={this.handleClick}
            type="button"
            data-test={`pill-${(testId || children).replace(/[^a-z0-9]/gi, '')}-action`}
            className="absolute cursor-pointer -top-1.5 -right-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-orange-600 text-white hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-1"
          >
            <svg
              className="h-2.5 w-2.5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={3}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
            <span className="sr-only">Remove</span>
          </button>
        )}
      </span>
    );
  }
}

Pill.propTypes = {
  testId: PropTypes.string,
  tooltip: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  handler: PropTypes.func,
};
